import React from 'react';
import _ from 'lodash';
import { Box } from '@mui/material';

type Props = {
  numSamples: number;
}

const SampleHeader: React.FC<Props> = ({ numSamples }: Props) => (
  <Box
    sx={{
      padding: '10px 10px',
      paddingLeft: '15%',
      background: '#eee',
    }}
  >
    <div className="flex nowrap innerWrapper">
      {_.times(numSamples, (idx) => (
        <span style={{ textAlign: 'center' }} key={`sampleHeader-${idx}`} className="basis-100">
          P
          {idx + 1}
        </span>
      ))}
    </div>
  </Box>
);

export default SampleHeader;
